module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division II18.73a8f09c.png";